export default __webpack_public_path__ + "static/media/E.598f1567.mp3";